export function getHolidayDetailItems({
  showAll = false,
  currentMonthHolidays = [],
  upcomingHolidays = [],
} = {}) {
  return showAll ? upcomingHolidays : currentMonthHolidays;
}
